import React, { useState, useEffect } from "react";
import { getEmpresa } from "../../../services/empresaservice";
import "./NavbarDashboard.css";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faHome,
  faUsers,
  faPlus,
  faBus,
  faIdBadge,
  faBuilding,
  faShieldAlt,
  faUser,
  faLock,
  faCubes,
  faBars,
  faList,
  faClipboardCheck,
  faClockRotateLeft,
  faMagnifyingGlassChart,
} from "@fortawesome/free-solid-svg-icons";

import logoDefault from "../../../assets/images/logo.png";

const BASE_IMAGE_URL = "https://jm.komerzy.com/backend/images/";

export default function NavbarDashboard({ user }) {
  const [open, setOpen] = useState({});
  const [mobileOpen, setMobileOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState(user);
  const [logoEmpresa, setLogoEmpresa] = useState(null);

  useEffect(() => {
    if (!user) {
      const storedUser = JSON.parse(localStorage.getItem("user"));
      setCurrentUser(storedUser);
    } else {
      setCurrentUser(user);
    }
  }, [user]);

  useEffect(() => {
    const fetchEmpresa = async () => {
      try {
        const data = await getEmpresa();
        let empresaData = null;

        if (data && !Array.isArray(data)) {
          empresaData = data;
        } else if (Array.isArray(data) && data.length > 0) {
          empresaData = data[0];
        }

        if (empresaData && empresaData.logo) {
          setLogoEmpresa(
            `${BASE_IMAGE_URL}${empresaData.logo}?v=${new Date().getTime()}`
          );
        }
      } catch (error) {
        console.error("Error cargando logo:", error);
      }
    };

    fetchEmpresa();
    window.addEventListener("empresaActualizada", fetchEmpresa);

    return () =>
      window.removeEventListener("empresaActualizada", fetchEmpresa);
  }, []);

  const rol = currentUser?.idrol ? Number(currentUser.idrol) : 0;

  const toggle = (key) => {
    setOpen((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  return (
    <nav className={`navbarDashboard ${mobileOpen ? "mobileOpen" : ""}`}>
      <div className="mobileTop">
        <Link
          to="/inicio"
          className="logoWrap"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textDecoration: "none",
            width: "70px",
            height: "100%",
            paddingLeft: "10px",
          }}
        >
          <div
            style={{
              width: "45px",
              height: "45px",
              borderRadius: "50%",
              overflow: "hidden",
              border: "2px solid #ffffff",
              backgroundColor: "#fff",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "5px",
              boxSizing: "border-box",
              flexShrink: 0,
            }}
          >
            <img
              src={logoEmpresa || logoDefault}
              alt="Logo"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                display: "block",
              }}
            />
          </div>
        </Link>

        <button
          className="mobileBtn"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          <FontAwesomeIcon icon={faBars} />
        </button>
      </div>

      <div
        className="links"
        onClick={(event) => {
          if (event.target.closest("a")) {
            setMobileOpen(false);
          }
        }}
      >

        {/* TABLERO */}
        <div className="menuGroup">
          <div className="menuTitle" onClick={() => toggle("tablero")}>
            <FontAwesomeIcon icon={faHome} />
            <span>Tablero</span>
            <FontAwesomeIcon
              icon={faChevronDown}
              className={`arrow ${open.tablero ? "rotate" : ""}`}
            />
          </div>

          {open.tablero && (
            <div className="submenu">
              <Link to="/inicio">
                <FontAwesomeIcon icon={faHome} />
                <span>Inicio</span>
              </Link>
            </div>
          )}
        </div>

        {/* PRODUCTOS */}
        <div className="menuGroup">
          <div className="menuTitle" onClick={() => toggle("productos")}>
            <FontAwesomeIcon icon={faClipboardCheck} />
            <span>Productos</span>
            <FontAwesomeIcon
              icon={faChevronDown}
              className={`arrow ${open.productos ? "rotate" : ""}`}
            />
          </div>

          {open.productos && (
            <div className="submenu">
              <Link to="/inicio/categorias">
                <FontAwesomeIcon icon={faList} />
                <span>Categorías</span>
              </Link>

              <Link to="/inicio/productos">
                <FontAwesomeIcon icon={faCubes} />
                <span>Productos</span>
              </Link>

              <Link to="/inicio/ajuste-inventario">
                <FontAwesomeIcon icon={faClockRotateLeft} />
                <span>Ajuste de Inventario</span>
              </Link>
            </div>
          )}
        </div>

     {/* COTIZACIONES: SOLO SUPERADMIN Y OPERADOR */}
        {(rol === 1 || rol === 2) && (
          <div className="menuGroup">
            <div
              className="menuTitle"
              onClick={() => toggle("cotizaciones")}
            >
              <FontAwesomeIcon icon={faClipboardCheck} />
              <span>Cotizaciones</span>
              <FontAwesomeIcon
                icon={faChevronDown}
                className={`arrow ${
                  open.cotizaciones ? "rotate" : ""
                }`}
              />
            </div>

            {open.cotizaciones && (
              <div className="submenu">

                {/* NUEVA COTIZACIÓN */}
                <Link to="/inicio/cotizacion/agregar">
                  <FontAwesomeIcon icon={faPlus} />
                  <span>Nueva Cotización</span>
                </Link>

                {/* HISTORIAL */}
                <Link to="/inicio/cotizacion">
                  <FontAwesomeIcon icon={faClockRotateLeft} />
                  <span>Historial de Cotizaciones</span>
                </Link>

              </div>
           )}
          </div>
        )}
        {/* REGISTRAR (PROVEEDORES MOVIDO AQUÍ) */}
        {(rol === 1 || rol === 2) && (
          <div className="menuGroup">
            <div className="menuTitle" onClick={() => toggle("registrar")}>
              <FontAwesomeIcon icon={faPlus} />
              <span>Registrar</span>
              <FontAwesomeIcon
                icon={faChevronDown}
                className={`arrow ${open.registrar ? "rotate" : ""}`}
              />
            </div>

            {open.registrar && (
              <div className="submenu">
                <Link to="/inicio/clientes">
                  <FontAwesomeIcon icon={faUsers} />
                  <span>Clientes</span>
                </Link>

                <Link to="/inicio/proveedores">
                  <FontAwesomeIcon icon={faBuilding} />
                  <span>Proveedores</span>
                </Link>

                <Link to="/inicio/empleado">
                  <FontAwesomeIcon icon={faIdBadge} />
                  <span>Empleado</span>
                </Link>

                <Link to="/inicio/vehiculo">
                  <FontAwesomeIcon icon={faBus} />
                  <span>Vehículos</span>
                </Link>
              </div>
            )}
          </div>
        )}

        {/* ADMINISTRACION */}
        {rol === 1 && (
          <div className="menuGroup">
            <div className="menuTitle" onClick={() => toggle("admin")}>
              <FontAwesomeIcon icon={faBuilding} />
              <span>Administración</span>
              <FontAwesomeIcon
                icon={faChevronDown}
                className={`arrow ${open.admin ? "rotate" : ""}`}
              />
            </div>

            {open.admin && (
              <div className="submenu">
                <Link to="/inicio/empresa">
                  <FontAwesomeIcon icon={faBuilding} />
                  <span>Empresa</span>
                </Link>
              </div>
            )}
          </div>
        )}

        {/* SEGURIDAD */}
        {rol === 1 && (
          <div className="menuGroup">
            <div className="menuTitle" onClick={() => toggle("seguridad")}>
              <FontAwesomeIcon icon={faShieldAlt} />
              <span>Seguridad</span>
              <FontAwesomeIcon
                icon={faChevronDown}
                className={`arrow ${open.seguridad ? "rotate" : ""}`}
              />
            </div>

            {open.seguridad && (
              <div className="submenu">
                <Link to="/inicio/usuarios">
                  <FontAwesomeIcon icon={faUser} />
                  <span>Usuarios</span>
                </Link>

                <Link to="/inicio/roles">
                  <FontAwesomeIcon icon={faLock} />
                  <span>Roles</span>
                </Link>

                <Link to="/inicio/modulos">
                  <FontAwesomeIcon icon={faCubes} />
                  <span>Módulos</span>
                </Link>

                <Link to="/inicio/auditoria">
                  <FontAwesomeIcon icon={faMagnifyingGlassChart} />
                  <span>Auditoría</span>
                </Link>
              </div>
            )}
          </div>
        )}

      </div>
    </nav>
  );
}